import { Flex, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

export const FormContainer = ({ children }: { children: React.ReactNode }) => {
  const background = useColorModeValue('white', 'black');

  return (
    <Flex
      boxShadow="0 15px 35px 0 rgb(60 66 87 / 8%), 0 5px 15px 0 rgb(0 0 0 / 12%)"
      borderRadius="5px"
      backgroundColor={background}
      width="100%"
      padding={['32px 8px', '32px 8px', '32px 8px', '32px 36px']}
    >
      {children}
    </Flex>
  );
};
